<template>
  <div class="world backgroundWhite">
    <div class="content">
      <el-form ref="form" :model="form" label-width="80px" class="form" :rules="rules">
        <el-form-item label="需求类型" prop="needsType">
          <el-radio-group v-model="form.needsType" v-if="userType=='2'">
            <el-radio-button v-for="(item,index) in needTypeList" :label="item.value" :key="index">{{item.label}}</el-radio-button>
          </el-radio-group>
          <el-radio-group v-model="form.needsType" v-else>
            <el-radio-button v-for="(item,index) in needDisList" :label="item.value" :key="index">{{item.label}}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item prop="expectTime" label="期望时间">
          <el-date-picker type="date" placeholder="选择日期" v-model="form.expectTime" class="width100" value-format="yyyy/MM/dd" popper-class="eagle-a11y-uncut"></el-date-picker>
        </el-form-item>

        <el-form-item label="需求内容">
          <el-input v-if="form.needsType =='系统操作类'" type="textarea" :rows="8" placeholder="请输入内容" v-model="form.needsContent">
          </el-input>
          <div class="job-form" v-else>
            <el-form-item prop="stuNum" style="margin-bottom:10px">
              <div class="label"><i class="required">*</i> 选择职位</div>
              <el-select v-model="form.jobId" @change="onchange" placeholder="请选择">
                <el-option v-for="item in options" :key="item.id" :label="item.jobName" :value="item.id">
                </el-option>
              </el-select>
              <el-link type="primary" v-if="curitem.id" :href="'/enterprise/publish/?id='+ curitem.id" target="_blank" :underline="false" style="margin:0 20px">修改职位</el-link>
              <el-link type="primary" :href="'/enterprise/publish/'"  style="margin:0 20px" target="_blank" :underline="false">添加职位</el-link>
            </el-form-item>
            <ul class="show-jobinfo" v-show="curitem.id">
              <li>
                <span> 招聘人数</span>
                <div>{{curitem.jobNumber}}</div>
              </li>
              <li>
                <span>残疾类别</span>
                <div>
                  <template v-for="item in curitem.distype">
                    {{item.disType}}/{{item.disTypeLevel}}
                  </template>
                </div>
              </li>
              <li>
                <span>经验要求</span>
                <div>{{curitem.exp}}</div>
              </li>
              <li>
                <span>学历要求</span>
                <div>{{curitem.edu}}</div>
              </li>
              <li>
                <span>工作地点</span>
                <div>{{curitem.provinceid}}{{curitem.cityid}}{{curitem.threeCityid}}{{curitem.address}}</div>
              </li>
            </ul>
            <!-- <el-form-item prop="stuNum" style="margin-bottom:10px">
              <div class="label"><i class="required">*</i> 招聘人数</div>
              <el-input-number v-model="form.stuNum" :controls="false" :min="0" :max="999" label="请输入招聘人数"></el-input-number>
            </el-form-item>
            <el-form-item prop="distype">
              <div class="label"><i class="required">*</i> 残疾类别</div>
              <ThreeLink codeType="disabled_type" codeLevel="2" :disabled="false" placeholder="请选择残疾类别" class="w336 " @setMValue="setScasValue($event, form, ['distype', 'dislv'])"
                :defaultValue="[form.distype, form.dislv]"></ThreeLink>
            </el-form-item>
            <el-form-item prop="exp">
              <div class="label"><i class="required">*</i> 经验要求</div>
              <MulSelects :code="'user_word'" class="420" placeholder="请选择经验" @setMValue="setSelectValue($event, 'exp')" :defaultValue="form.exp"></MulSelects>
            </el-form-item>
            <el-form-item prop="edu">
              <div class="label"><i class="required">*</i> 学历要求</div>
              <MulSelects :code="'user_edu'" class="420" placeholder="请选择学历要求" @setMValue="setSelectValue($event, 'edu')" :defaultValue="form.edu"></MulSelects>
            </el-form-item>
            <el-form-item prop="provinceid">
              <div class="label"><i class="required">*</i> 工作地点</div>
              <ThreeLink :codeType="'provinceid'" :codeLevel="'3'" placeholder="请选择工作地点" class="" @setMValue="setScasValue($event,form,['provinceid','cityid','threeCityid'])"
                :defaultValue="[form.provinceid,form.cityid,form.threeCityid]"></ThreeLink>
            </el-form-item> -->
          </div>
        </el-form-item>
        <el-form-item class="buttons text_C">
          <el-button class="w150 marR20" @click="close">取消</el-button>
          <span class="marL20"></span>
          <el-button type="primary" class="w150" @click="save('form')">保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import Editor from 'components/public/editor';
import ThreeLink from 'components/selectComponents/ThreeLink';
import MulSelects from 'components/selectComponents/MulSelects';
let that = null;
let jobFrom = {
  stuNum: '',
  exp: '',
  edu: '',
  provinceid: '',
  cityid: '',
  threeCityid: '',
  distype: '',
  dislv: ''
};
export default {
  name: 'demeandInput',
  components: { Editor, ThreeLink, MulSelects },
  data() {
    return {
      content: '',
      userType: '',
      form: {
        jobId: '',
        expectTime: '',
        needsContent: '',
        needsType: '系统操作类'
        // ...jobFrom
      },
      options: [],
      // form: {
      //   expectTime: '',
      //   needsContent: '',
      //   needsType: '招聘类'
      // },
      curitem: {},
      jobForm: {
        stuNum: '',
        exp: '',
        edu: '',
        provinceid: '',
        cityid: '',
        threeCityid: '',
        distype: '',
        dislv: ''
      },
      needTypeList: [
        { value: '系统操作类', label: '系统操作类' },
        { value: '招聘类', label: '招聘类' }
      ],
      needDisList: [
        { value: '机构培训', label: '机构培训' },
        { value: '课件学习', label: '课件学习' },
        { value: '创业', label: '创业' },
        { value: '就业', label: '就业' }
      ],
      rules: {
        needsType: [
          {
            required: true,
            message: '请选择需求类型',
            trigger: ['submit', 'change']
          }
        ],
        expectTime: [
          {
            required: true,
            message: '请选择期望时间',
            trigger: ['submit', 'change']
          }
        ],
        jobId: [
          {
            validator: (rule, value, callback) => {
              console.log(this);
              if (this.form.needsType == '招聘类') {
                if (!value) {
                  callback(new Error('请选择职位或添加职位'));
                } else {
                  callback();
                }
              }
            },
            message: '请选择职位或添加职位',
            trigger: ['submit', 'change']
          }
        ],
        needsContent: [
          {
            validator: (rule, value, callback) => {
              console.log(this);
              if (this.form.needsType == '系统操作类') {
                if (!value) {
                  callback(new Error('请输入需求内容'));
                } else {
                  callback();
                }
              }
            },
            message: '请输入需求内容',
            trigger: ['submit', 'change']
          }
        ]
        // stuNum: [
        //   {
        //     validator: (rule, value, callback) => {
        //       console.log(this);
        //       if (this.form.needsType == '招聘类') {
        //         if (!value) {
        //           callback(new Error('请输入招聘人员'));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     message: '请输入招聘人员',
        //     trigger: ['submit', 'change']
        //   }
        // ],
        // exp: [
        //   {
        //     validator: (rule, value, callback) => {
        //       console.log(this);
        //       if (this.form.needsType == '招聘类') {
        //         if (!value) {
        //           callback(new Error('请选择经验'));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     message: '请选择经验',
        //     trigger: ['submit', 'change']
        //   }
        // ],
        // edu: [
        //   {
        //     validator: (rule, value, callback) => {
        //       console.log(this);
        //       if (this.form.needsType == '招聘类') {
        //         if (!value) {
        //           callback(new Error('请选择学历要求'));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     message: '请选择学历要求',
        //     trigger: ['submit', 'change']
        //   }
        // ],
        // provinceid: [
        //   {
        //     validator: (rule, value, callback) => {
        //       console.log(this);
        //       if (this.form.needsType == '招聘类') {
        //         if (!value) {
        //           callback(new Error('请选择地区'));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     message: '请选择地区',
        //     trigger: ['submit', 'change']
        //   }
        // ],
        // distype: [
        //   {
        //     validator: (rule, value, callback) => {
        //       console.log(this);
        //       if (this.form.needsType == '招聘类') {
        //         if (!value) {
        //           callback(new Error('请选择残疾类别'));
        //         } else {
        //           callback();
        //         }
        //       }
        //     },
        //     message: '请选择残疾类别',
        //     trigger: ['submit', 'change']
        //   }
        // ]
      }
    };
  },
  methods: {
    setSelectValue(val, key) {
      this.form[key] = val;
    },
    setScasValue(event, form, keys) {
      for (let i = 0; i < keys.length; i++) {
        let value = event[i];
        if (!value) {
          value = '';
        }
        let key = keys[i];
        form[key] = value;
      }
    },
    close() {
      this.$emit('close', false);
    },
    text(val) {
      this.form.needsContent = val;
    },
    save(form) {
      if (!this.form.needsType) {
        this.$message.error('请选择需求类型');
        return;
      }
      // if (!this.form.expectTime) {
      //   this.$message.error('请选择期望时间');
      //   return;
      // }
      // if (this.form.needsType == '系统操作类') {
      //   if (!this.form.needsContent) {
      //     this.$message.error('请选择需求内容');
      //     return;
      //   }
      // }
      let params = this.form.needsType == '系统操作类' ? { ...this.form, ...jobFrom } : this.form;
      this.$refs[form].validate(async valid => {
        if (valid) {
          let res = await this.$api.addNeed({ ...params, userType: this.userType });
          if (res.data.success) {
            this.$message.success('需求添加成功');
            this.close(0);
            this.$parent.$parent.needsList();
          } else {
            this.$message.error(res.message);
          }
        }
      });
    },
    onchange(val) {
      let curitem = this.options.filter(item => item.id == val);
      this.curitem = curitem[0] || {};
    }
  },
  mounted() {
    that = this;
    this.$api
      .getCompanyJobs({
        companyId: this.memberId
      })
      .then(res => {
        res = res.data;
        this.options = res.data || [];
      });
  },
  created() {
    let login = JSON.parse(localStorage.getItem('userInfo') || null);
    if (login) {
      this.memberId = login.id;
      this.userType = login.userType;
    }
  }
};
</script>

<style scoped lang="less">
.child_content .title h1 {
  transform: translateY(-10px);
}
.show-jobinfo {
  li {
    display: flex;
    margin-bottom: 10px;
    & > span {
      display: inline-block;
      width: 75px;
    }
    & > div {
      background: #f5f5f5;
      padding: 0 10px;
      min-width: 350px;
    }
  }
}
/deep/ .el-form-item .el-form-item {
  margin-bottom: 10px !important;
  .label {
    line-height: 22px;
  }
  .el-input {
    width: 300px;
  }
  .required {
    color: #f56c6c;
  }
}
// .job-form {
//   display: flex;
//   flex-wrap: wrap;
//   .el-form-item {
//     width: 50%;
//     .el-select,
//     .el-cascader {
//       width: 90%;
//     }
//   }
// }
</style>
